import { render, staticRenderFns } from "./SearchMovie.vue?vue&type=template&id=16b774b4&scoped=true"
import script from "./SearchMovie.vue?vue&type=script&lang=js"
export * from "./SearchMovie.vue?vue&type=script&lang=js"
import style0 from "./SearchMovie.vue?vue&type=style&index=0&id=16b774b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b774b4",
  null
  
)

export default component.exports